export default {"src":"/_next/static/media/content-hub-van.e3cfbe1e.svg","height":275,"width":1920,"blurWidth":0,"blurHeight":0};